import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  generationsLeft: null,
  iMaxAllowedGeneration: null,
  iGenerationCount: null,
  isLimitReached: false,
  iUserId: null,
  loading: false,
  error: null,
  lastUpdated: null,
};

export const generationSlice = createSlice({
  name: "generation",
  initialState,
  reducers: {
    setGenerationStats: (state, action) => {
      const payload = action.payload || {};
      const generationsLeft =
        typeof payload.generationsLeft === "number"
          ? payload.generationsLeft
          : payload.generationsLeft !== undefined && payload.generationsLeft !== null
          ? Number(payload.generationsLeft)
          : state.generationsLeft;

      const iMaxAllowedGeneration =
        typeof payload.iMaxAllowedGeneration === "number"
          ? payload.iMaxAllowedGeneration
          : payload.iMaxAllowedGeneration !== undefined && payload.iMaxAllowedGeneration !== null
          ? Number(payload.iMaxAllowedGeneration)
          : state.iMaxAllowedGeneration;

      const iGenerationCount =
        typeof payload.iGenerationCount === "number"
          ? payload.iGenerationCount
          : payload.iGenerationCount !== undefined && payload.iGenerationCount !== null
          ? Number(payload.iGenerationCount)
          : state.iGenerationCount;

      state.generationsLeft = Number.isFinite(generationsLeft) ? Math.max(0, generationsLeft) : 0;
      state.iMaxAllowedGeneration = Number.isFinite(iMaxAllowedGeneration) ? iMaxAllowedGeneration : null;
      state.iGenerationCount = Number.isFinite(iGenerationCount) ? iGenerationCount : null;
      state.isLimitReached =
        Boolean(payload.isLimitReached) ||
        (state.generationsLeft !== null && state.generationsLeft <= 0);
      state.iUserId = payload.iUserId ?? state.iUserId;
      state.loading = false;
      state.error = null;
      state.lastUpdated = Date.now();
    },
    decrementGenerationsLeft: (state, action) => {
      const count = typeof action.payload === "number" && action.payload > 0 ? action.payload : 1;
      if (typeof state.generationsLeft === "number") {
        state.generationsLeft = Math.max(0, state.generationsLeft - count);
        state.isLimitReached = state.generationsLeft <= 0;
      }
      if (typeof state.iGenerationCount === "number") {
        state.iGenerationCount += count;
      }
      state.lastUpdated = Date.now();
    },
    setGenerationLoading: (state, action) => {
      state.loading = Boolean(action.payload);
    },
    setGenerationError: (state, action) => {
      state.loading = false;
      state.error = action.payload || null;
    },
    resetGenerationStats: (state) => {
      state.generationsLeft = null;
      state.iMaxAllowedGeneration = null;
      state.iGenerationCount = null;
      state.isLimitReached = false;
      state.iUserId = null;
      state.loading = false;
      state.error = null;
      state.lastUpdated = null;
    },
  },
});

export const {
  setGenerationStats,
  decrementGenerationsLeft,
  setGenerationLoading,
  setGenerationError,
  resetGenerationStats,
} = generationSlice.actions;

export default generationSlice.reducer;
